import * as yup from "yup";

const externalLinkSchema = yup.object().shape(
	{
		Url: yup
			.string()
			.default("")
			.nullable()
			.transform((v: string | null | undefined) => v || null)
			.test(
				"url",
				"Must be a valid URL starting with http",
				(value) => !value || value.startsWith("http"),
			)
			.when("Name", ([name], schema) => (name ? schema.required() : schema)),
		Name: yup
			.string()
			.default("")
			.nullable()
			.when("Url", ([url], schema) => (url ? schema.required() : schema)),
	},
	[["Url", "Name"]],
);

export const ShiftSettingsValidation = yup.object().shape({
	DefaultSystemId: yup.number(),
	DefaultGroupId: yup.number(),
	DefaultShiftId: yup.number(),
	ExternalLinkOne: externalLinkSchema,
	ExternalLinkTwo: externalLinkSchema,
	ExternalLinkThree: externalLinkSchema,
});
